<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link"><router-link to="/loja" class="fa fa-home"></router-link></li>
          <li class="item-link"><router-link to="/login" class="wrap-breadcrumb ul span">Login</router-link></li>
          <li class="item-link"><span>Cadastro</span></li>
        </ul>
      </div>
      <div class="main-content-area">
        <div>
          <h2>Falta pouco para que você possa se tornar cliente da Aldo!</h2>

          <div class="row">
            <div class="col-md-12">
              <ul class="obs">
                <li>Atenção para os pontos abaixo:</li>
                <li>Só serão aceitos os cadastros preenchidos abaixo. Não recebemos por e-mail</li>
                <li>Fique atento se aparecer algum exemplo ao lado do campo inserido, faça semelhante ao modelo</li>
                <li>Para que o cadastro seja aceito, ele deve ser preenchido corretamente</li>
                <li>Caso tenha dúvidas, entre em contato conosco pelo e-mail: <a href="mailto:cadastro@aldo.com.br">cadastro@aldo.com.br</a></li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <form @submit.prevent="register" action="#" method="get" name="frm-billing">
                <!-- Dados da Empresa -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Dados da Empresa</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.cnpj"
                      :form="formRegister"
                      validationType="cnpj"
                      label="CNPJ"
                      mask="##.###.###/####-##"
                      :disabled="true"
                    ></FormHelper>
                  </div>
                  <div v-if="loadingCnpj" class="col-md-6">
                    <Loader style="margin-top: 20px" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.razaoSocial"
                      :form="formRegister"
                      maxlength="60"
                      label="Razão Social"
                      :disabled="formRegister.disabledForm || disabledAll"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.nomeFantasia"
                      :form="formRegister"
                      validationType="quotes"
                      maxlength="60"
                      label="Nome Fantasia"
                      :disabled="formRegister.nomeFantasiaDisabled || disabledAll"
                    ></FormHelper>
                  </div>
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.contratoSocial"
                      :form="formRegister"
                      label="Contrato Social ou Certificado MEI"
                      type="file"
                      :fileTypes="['pdf', 'jpg', 'png']"
                      :disabled="disabledAll"
                    />
                  </div>
                </div>

                <!-- Endereço -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Endereço</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <!-- ValidationType = Local é aplicado quando o input é validado localmente no componente -->
                    <FormHelper
                      :inputVar="formRegister.cep"
                      :form="formRegister"
                      validationType="local"
                      label="CEP"
                      placeholder="Ex.: 87013-000"
                      mask="#####-###"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.endereco"
                      :form="formRegister"
                      maxlength="60"
                      label="Endereço"
                      :disabled="formRegister.enderecoDisabled || disabledAll"
                    >
                    </FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.estado"
                      :form="formRegister"
                      :options="getStates()"
                      type="select"
                      label="Estado"
                      placeholder="Selecione um Estado"
                      :disabled="formRegister.estadoDisabled || disabledAll"
                    >
                    </FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.cidade"
                      :form="formRegister"
                      :options="formRegister.cidades"
                      type="select"
                      label="Cidade"
                      placeholder="Selecione uma Cidade"
                      :disabled="formRegister.cidadeDisabled || disabledAll"
                    >
                    </FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.bairro"
                      :form="formRegister"
                      maxlength="60"
                      label="Bairro"
                      placeholder="Digite o Bairro"
                      :disabled="formRegister.bairroDisabled || disabledAll"
                    >
                    </FormHelper>
                  </div>
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.numero"
                      :form="formRegister"
                      maxlength="60"
                      label="Número"
                      placeholder="Digite o Número"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.complemento"
                      :form="formRegister"
                      validationType="quotes"
                      maxlength="60"
                      label="Complemento"
                      placeholder="Digite o Complemento"
                      :disabled="formRegister.complementoDisabled || disabledAll"
                    >
                    </FormHelper>
                  </div>
                </div>

                <!-- Dados Fiscais -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Dados Fiscais</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.regimeTributario"
                      :form="formRegister"
                      :options="getTaxRegimeOptions()"
                      type="select"
                      label="Informe o Regime Tributário da sua empresa"
                      placeholder="Selecione um Regime"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <div class="row-in-form">
                      <label for="cnae">CNAE <span>*</span></label>

                      <input
                        id="cnae"
                        type="text"
                        placeholder="Ex.: 47.51-2-01"
                        v-mask="'##.##-#-##'"
                        v-model="formRegister.cnae.value"
                        :disabled="disabledAll"
                        :class="{ 'is-invalid': !formRegister.cnae.validation.status && formRegister.attemptSubmit }"
                      />
                      <span v-if="!formRegister.cnae.validation.status && formRegister.attemptSubmit" class="invalid-feedback">{{
                        formRegister.cnae.validation.message
                      }}</span>

                      <small>Classificação Nacional de Atividades Econômicas</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.inscricaoEstadual"
                      :form="formRegister"
                      maxlength="20"
                      :disabled="disabledAll"
                      label="Inscrição Estadual"
                      placeholder="Digite a IE"
                    >
                    </FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.fundacao"
                      :form="formRegister"
                      validationType="pastDate"
                      label="Fundação"
                      placeholder="Ex.: dd/mm/aaaa"
                      icon="fa-calendar"
                      mask="##/##/####"
                      :disabled="formRegister.disabledForm || disabledAll"
                    >
                    </FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <FormHelper
                      :inputVar="formRegister.mei"
                      :form="formRegister"
                      :options="yesOrNoOptions()"
                      type="radio"
                      label="MEI - Microempreendedor Individual?"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>
                </div>

                <!-- Contato -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Contato</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.telefoneCelular"
                      validationType="phone"
                      :form="formRegister"
                      maxlength="16"
                      label="Celular/WhatsApp Responsável da Empresa"
                      placeholder="(99) 99999-9999"
                      icon="fa-phone"
                      :disabled="disabledAll"
                      :mask="['(##) #########']"
                    >
                    </FormHelper>
                  </div>
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.telefone"
                      validationType="phone"
                      :form="formRegister"
                      maxlength="16"
                      label="Celular/WhatsApp Setor Compras"
                      placeholder="(99) 99999-9999"
                      icon="fa-phone"
                      :disabled="disabledAll"
                      :mask="['(##) #########']"
                    >
                    </FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.email"
                      :form="formRegister"
                      validationType="email"
                      label="E-mail"
                      placeholder="Ex.: contato@empresa.com.br"
                      icon="fa-envelope"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.confirmeEmail"
                      :form="formRegister"
                      validationType="comparison"
                      :compareTo="formRegister.email"
                      label="Confirme seu E-mail"
                      :disabled="disabledAll"
                      placeholder="Ex.: contato@empresa.com.br"
                      icon="fa-envelope"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.site"
                      :form="formRegister"
                      maxlength="50"
                      validationType="website"
                      :disabled="disabledAll"
                      label="Site"
                      placeholder="Ex.: http://www.suaempresa.com.br"
                      icon="fa-globe"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.nomeQuemCadastrou"
                      :form="formSocio"
                      validationType="quotes"
                      maxlength="60"
                      label="Nome do Responsável pelo Cadastro"
                      placeholder="Nome do Responsável pelo Cadastro"
                      :disabled="true"
                    >
                    </FormHelper>
                  </div>
                </div>

                <!-- Sócio/Proprietário -->
                <div id="partner" v-if="socios.length - socioIndex > 0">
                  <div class="row">
                    <div class="col-md-12">
                      <h3 class="box-title">Sócio/Proprietário</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <h5 class="alert alert-info">
                        Quantidade de sócios a serem adicionados: {{ socios.length - socioIndex }}
                        sócios.
                      </h5>
                    </div>
                  </div>

                  <form @submit.prevent="savePartner">
                    <div class="row">
                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.cpfSocio"
                          :form="formSocio"
                          validationType="cpf"
                          mask="###.###.###-##"
                          label="CPF"
                          placeholder="Digite o CPF"
                          :disabled="disabledAll"
                        ></FormHelper>
                      </div>

                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.dataNascimentoSocio"
                          :form="formSocio"
                          validationType="pastDate"
                          icon="fa-calendar"
                          mask="##/##/####"
                          label="Data de Nascimento"
                          placeholder="Digite a Data de Nascimento"
                          :disabled="disabledAll"
                        >
                        </FormHelper>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.nomeSocio"
                          :form="formSocio"
                          validationType="quotes"
                          maxlength="60"
                          label="Nome"
                          placeholder="Informe o CPF e a data de nascimento"
                          :disabled="true"
                        >
                        </FormHelper>
                      </div>

                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.rgSocio"
                          :form="formSocio"
                          label="RG"
                          mask="##############"
                          :disabled="disabledAll"
                          placeholder="Digite o RG"
                        ></FormHelper>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.cargoSocio"
                          :form="formSocio"
                          validationType="quotes"
                          maxlength="50"
                          label="Cargo"
                          placeholder="Digite o Cargo"
                          icon="fa-briefcase"
                          :disabled="disabledAll"
                        ></FormHelper>
                      </div>

                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.emailSocio"
                          :form="formSocio"
                          maxlength="50"
                          id="email-socio"
                          validationType="email"
                          icon="fa-envelope"
                          label="E-mail"
                          placeholder="Digite o E-mail"
                          :disabled="disabledAll"
                        >
                        </FormHelper>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <FormHelper
                          :inputVar="formSocio.telefoneSocio"
                          :form="formSocio"
                          maxlength="15"
                          id="telefone-socio"
                          validationType="phone"
                          label="Telefone"
                          :mask="['(##) ####-####', '(##) #####-####']"
                          placeholder="Digite o Telefone"
                          icon="fa-phone"
                          :disabled="disabledAll"
                        >
                        </FormHelper>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <button
                          aria-label="Adicionar Sócio"
                          id="btnPartner"
                          class="btn primary-button pull-left"
                          type="submit"
                          :disabled="disabledAll"
                        >
                          Adicionar Sócio
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div v-else-if="hasPartners">
                  <div class="row">
                    <div class="col-md-12">
                      <h3 class="box-title">Sócio/Proprietário</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="alert alert-success">Todos os sócios foram adicionados!</h4>
                    </div>
                  </div>
                </div>
                <div v-else-if="!hasPartners">
                  <div class="row">
                    <div class="col-md-12">
                      <h3 class="box-title">Sócio/Proprietário</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="alert alert-warning">Esta empresa não contém sócios cadastrados na receita!</h4>
                    </div>
                  </div>
                </div>

                <!-- Responsável pela Nota Fiscal Eletrônica (NF-e) -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Responsável pela Nota Fiscal Eletrônica (NF-e)</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.nomeResponsavel"
                      :form="formRegister"
                      validationType="quotes"
                      maxlength="60"
                      id="nome-responsavel"
                      label="Nome"
                      placeholder="Digite o Nome"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.emailResponsavel"
                      :form="formRegister"
                      id="email-responsavel"
                      validationType="email"
                      icon="fa-envelope"
                      label="E-mail"
                      placeholder="Digite o E-mail"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>
                </div>

                <!-- Sobre sua conta -->
                <!-- Como conheceu a Aldo -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Como conheceu a Aldo</h3>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.comoConheceu"
                      :form="formRegister"
                      maxlength="60"
                      type="select"
                      :options="getMeetOptions()"
                      label="Selecione como conheceu a Aldo"
                      placeholder="Selecione como conheceu a Aldo"
                      :disabled="disabledAll"
                    ></FormHelper>
                  </div>
                </div>

                <div v-if="formRegister.attemptSubmit && formErrors > 0" class="row">
                  <div class="col-md-12">
                    <div class="form-errors alert alert-danger" role="alert">
                      <i class="fa fa-warning"></i>
                      Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <button
                      v-if="!disabledAll"
                      aria-label="Salvar Cadastro"
                      class="btn primary-button"
                      type="submit"
                      :disabled="(formRegister.attemptSubmit && formErrors > 0) || loadingRegister"
                    >
                      Salvar Cadastro
                    </button>
                  </div>
                  <div v-if="loadingRegister" class="col-md-6">
                    <Loader />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CnaeModal></CnaeModal>
  </main>
</template>

<script>
import CnaeModal from './partials/CnaeModal.vue'
import FormHelper from './partials/FormHelper.vue'
import axios from 'axios'

export default {
  name: 'Register',
  data() {
    return {
      loadingCnpj: false,
      requiredFieldMessage: 'Por favor, preencha o campo acima',
      atividadesSecundarias: [],
      formRegister: {
        attemptSubmit: false,
        //Para tirar a obrigatoriedade do campo informe "new this.$formInput(false)"
        // Dados da Empresa
        cnpj: new this.$formInput(true, this.$route.params.cnpj), // Parâmetros: Required / Value
        razaoSocial: new this.$formInput(),
        nomeFantasia: new this.$formInput(false),
        contratoSocial: new this.$formInput(false),
        // Endereço
        estado: new this.$formInput(),
        cidade: new this.$formInput(),
        cep: new this.$formInput(),
        endereco: new this.$formInput(),
        numero: new this.$formInput(),
        bairro: new this.$formInput(),
        complemento: new this.$formInput(false),
        comprovanteEndereco: new this.$formInput(false),
        // Dados Fiscais
        regimeTributario: new this.$formInput(),
        cnae: new this.$formInput(),
        inscricaoEstadual: new this.$formInput(false),
        fundacao: new this.$formInput(),
        mei: new this.$formInput(true, false),
        // Contato
        telefone: new this.$formInput(),
        telefoneCelular: new this.$formInput(),
        nomeQuemCadastrou: new this.$formInput(),
        site: new this.$formInput(false),
        email: new this.$formInput(),
        confirmeEmail: new this.$formInput(),
        // Responsável pela Nota Fiscal
        nomeResponsavel: new this.$formInput(),
        emailResponsavel: new this.$formInput(),
        // Sobre sua Conta
        // Aldo
        comoConheceu: new this.$formInput(),
        cidades: [],
        disabledForm: true,
        cidadeDisabled: false,
        complementoDisabled: true,
        nomeFantasiaDisabled: true,
        estadoDisabled: true,
        enderecoDisabled: true,
        bairroDisabled: true
      },
      formSocio: {
        nomeSocio: new this.$formInput(),
        cpfSocio: new this.$formInput(),
        rgSocio: new this.$formInput(),
        dataNascimentoSocio: new this.$formInput(),
        cargoSocio: new this.$formInput(),
        emailSocio: new this.$formInput(),
        telefoneSocio: new this.$formInput(),
        attemptSubmit: false
      },
      socios: [],
      socioIndex: 0,
      hasPartners: false,
      loadingRegister: false,
      session: null,
      situacaoCadastro: 0,
      disabledAll: false,
      loading: false,
      temInfosCnpj: false,
      temInfosFinancialCnpj: false
    }
  },
  components: {
    CnaeModal,
    FormHelper
  },
  mounted() {
    const logon = localStorage.getItem('usuarioLogado')
    if (logon) {
      this.session = JSON.parse(logon)
      this.situacaoCadastro = this.session.DadosCliente.SituacaoCadastro

      if (this.session.DadosCliente.SituacaoCadastro !== 1) {
        this.disabledAll = true
      }
    }

    this.loadingCnpj = true
    this.getByCnpj(this.$route.params.cnpj)
  },
  computed: {
    formErrors: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formRegister).filter(
        (key) => this.formRegister[key].required && this.formRegister[key].validation && !this.formRegister[key].validation.status
      )

      let errorsSocio = []
      if (this.hasPartners && this.socios.length == 0) {
        errorsSocio = Object.keys(this.formSocio).filter(
          (key) => this.formSocio[key].required && this.formSocio[key].validation && !this.formSocio[key].validation.status
        )
      }
      return errorsSocio.length + errors.length
    },
    formSocioErrors: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formSocio).filter(
        (key) => this.formSocio[key].required && this.formSocio[key].validation && !this.formSocio[key].validation.status
      )
      return errors.length
    }
  },
  watch: {
    'formRegister.estado.value': function (val) {
      this.loadCidades()
    },
    'formRegister.cep.value': function (val) {
      const self = this

      this.formRegister.cep.validation = this.requiredValidation(val)
      if (!(val.length === 9)) {
        self.formRegister.cep.validation = self.buildError('CEP inválido')
      } else this.getCepInfos(val)
    },
    'formRegister.cnae.value': async function (val) {
      this.formRegister.cnae.validation = this.requiredValidation(val)

      // Caso o campo de CNAE esteja preenchido
      if (this.formRegister.cnae.validation.status) {
        // Verifica se a quantidade de números do CNAE está correto
        val = this.clearString(val)

        let validate = await this.validateCnae(val)
        console.log('Validação Cnae ',val.length, validate)
        if (val.length < 7 || !validate) {
          // Retorna erro de validação
          this.formRegister.cnae.validation = this.buildError('CNAE inválido')
        }
      }
    },
    'formRegister.socio.value': function (val) {
      this.formRegister.nomeSocio.value = val
    }
  },
  methods: {
    removeAcento(text) {
      text = text.toLowerCase()
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
      return text
    },
    getCepInfos(cep) {
      this.formRegister.complementoDisabled = false
      cep = cep.replace(/-/g, '')
      axios.get(`${this.$apiUrl}Cliente.svc/buscaCEP/?cep=${cep}`).then((response) => {
        if (response.data !== '') {
          let cep = JSON.parse(response.data)
          if (cep.Bairro == null) {
            this.formRegister.cep.value = ''
            this.formRegister.endereco.value = ''
            this.formRegister.bairro.value = ''
            this.formRegister.cidadeDisabled = false
            return
          }

          if (cep.Endereco) {
            this.formRegister.endereco.value = this.removeAcento(cep.Endereco).replace(',', '').replace("'", '').toUpperCase()
            this.formRegister.bairro.value = this.removeAcento(cep.Bairro).replace(',', '').replace("'", '').toUpperCase()
            this.formRegister.estado.value = cep.UF.toUpperCase()
            this.formRegister.cidade.value = this.removeAcento(cep.Cidade).toUpperCase()
          } else {
            this.formRegister.endereco.value = ''
            this.formRegister.bairro.value = ''
          }

          this.formRegister.enderecoDisabled = cep.Endereco !== ''
          this.formRegister.bairroDisabled = cep.Bairro !== ''

          if (cep.UF) {
            let estados = this.getStates()
            let estado = estados.filter((c) => c.code == cep.UF)[0]

            if (
              this.formRegister.cidade.value.label != null &&
              this.removeAcento(cep.Endereco).toUpperCase() != this.frmEndereco.cidade.value.label
            ) {
              swal({
                title: 'Aviso',
                text: 'A cidade selecionada não é a mesma do CEP',
                icon: 'warning'
              })
              this.formRegister.estadoDisabled = false
              this.formRegister.cidadeDisabled = false
            } else {
              this.formRegister.estadoDisabled = true
              this.formRegister.cidadeDisabled = true
            }
            this.formRegister.estado.value = estado
            this.formRegister.cidade.value = this.removeAcento(cep.Endereco).toUpperCase()
          } else {
            this.formRegister.cidadeDisabled = false
          }
        } else {
          this.formRegister.enderecoDisabled = false
          this.formRegister.estadoDisabled = false
          this.formRegister.cidadeDisabled = false
          this.formRegister.bairroDisabled = false
        }
      })
    },
    savePartner() {
      this.formSocio.attemptSubmit = true
      if (this.socioIndex > 0 && this.socios.length > 0) {
        let validaSocioRepetido = this.socios.filter((c) => c.PresocCpf && c.PresocCpf == this.formSocio.cpfSocio.value).length > 0
        if (validaSocioRepetido) {
          swal({
            title: 'Este sócio já está adicionado!',
            text: 'Digite outro CPF, por gentileza!',
            icon: 'warning'
          })
          return
        }
      }
      if (this.formSocioErrors === 0) {
        var dataSocioString = this.formSocio.dataNascimentoSocio.value.split('/')
        var dataNascSocio = new Date(dataSocioString[2] + '-' + dataSocioString[1] + '-' + dataSocioString[0] + 'T00:00:00')

        let socio = {}
        socio.PresocNome = this.formSocio.nomeSocio.value
        socio.PresocRg = this.formSocio.rgSocio.value
        socio.PresocCpf = this.formSocio.cpfSocio.value
        socio.PresocCargo = this.formSocio.cargoSocio.value
        socio.PresocDatanasc = '/Date(' + dataNascSocio.getTime() + '-0300)/'
        socio.PresocEmail = this.formSocio.emailSocio.value
        socio.PresocTelefone = this.formSocio.telefoneSocio.value
        if (this.socios[this.socioIndex]) {
          this.socios[this.socioIndex] = socio
          this.socioIndex++
        }

        this.clearPartnerInputs()
        if (this.socios[this.socioIndex]) {
          this.formSocio.nomeSocio.value = this.socios[this.socioIndex].label
          this.formSocio.cargoSocio.value = this.socios[this.socioIndex].value.slice(3).trim()
        }

        this.formSocio.attemptSubmit = false
        swal({
          title: 'Sócio adicionado com sucesso!',
          icon: 'success'
        })
      }
    },
    clearPartnerInputs() {
      this.formSocio.attemptSubmit = false
      this.formSocio.nomeSocio.value = ''
      this.formSocio.rgSocio.value = ''
      this.formSocio.cpfSocio.value = ''
      this.formSocio.cargoSocio.value = ''
      this.formSocio.emailSocio.value = ''
      this.formSocio.telefoneSocio.value = ''
      this.formSocio.dataNascimentoSocio.value = ''
    },
    getInfosFinancialCnpj(cnpj) {
      this.loadingCnpj = true
      axios
        .get(`${this.$apiUrl}Cliente.svc/infos-financeiras-cnpj/${cnpj}/R`)
        .then((response) => {
          if (response.data) {
            let infosFinanceiras = response.data
            if (infosFinanceiras.regime_tributacao) {
              let regimeTributario = infosFinanceiras.regime_tributacao.split('-')[0].trim()
              regimeTributario = this.getTaxRegimeOptions().filter((c) => c.label.toLowerCase().includes(regimeTributario.toLowerCase()))[0]
              if (regimeTributario) this.formRegister.regimeTributario.value = regimeTributario
            }
            this.formRegister.inscricaoEstadual.value = infosFinanceiras.inscricao_estadual
            this.temInfosFinancialCnpj = true
          } else {
            this.temInfosFinancialCnpj = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.loadingCnpj = false
          this.temInfosFinancialCnpj = false
        })
    },
    getInfosCnpj(cnpj) {
      this.loadingCnpj = true
      axios
        .get(this.$apiUrl + `Cliente.svc/infos-cnpj/${cnpj}/R`)
        .then((response) => {
          this.loadingCnpj = false
          let empresa = response.data
          if (!(empresa.code == '0')) {
            swal({
              title: 'Não foi possível validar seu CNPJ',
              text: empresa.message,
              icon: 'warning'
            }).then((confirm) => {
              if (confirm) {
                this.formRegister.disabledForm = false
                this.formRegister.complementoDisabled = false
                this.formRegister.nomeFantasiaDisabled = false
                this.temInfosCnpj = false
              }
            })
          } else {
            this.formRegister.razaoSocial.value = empresa.nome.replace(/[,"']/g, '').slice(0, 60)
            this.formRegister.cep.value = empresa.cep
            this.formRegister.endereco.value = empresa.logradouro.slice(0, 60)
            this.formRegister.numero.value = empresa.numero
            if (empresa.complemento.replace(/\*/g, '') == '') this.formRegister.complementoDisabled = false
            else this.formRegister.complemento.value = empresa.complemento.slice(0, 60)

            this.formRegister.cnae.value = empresa.atividade_principal[0].code
            this.atividadesSecundarias = empresa.atividades_secundarias
            this.formRegister.fundacao.value = empresa.data_situacao
            let telefones = empresa.telefone.split('/')
            this.formRegister.telefone.value = telefones[0].trim()
            this.formRegister.bairro.value = empresa.bairro.slice(0, 60)
            this.formRegister.nomeFantasia.value = empresa.fantasia.replace(/[,"']/g, '').slice(0, 60)
            let estados = this.getStates()
            let estado = estados.filter((c) => c.code == empresa.uf)[0]
            this.formRegister.estado = new this.$formInput(true, estado)
            this.formRegister.cidade.value = empresa.municipio

            if (empresa.qsa && empresa.qsa.length > 0 && empresa.qsa[0] && empresa.qsa[0].nome && empresa.qsa[0].nome.trim()) {
              this.hasPartners = true
              this.socios = []

              empresa.qsa.forEach((element, index) => {
                if (element && element.nome && element.nome.trim()) {
                  let socio = {
                    code: index,
                    label: element.nome.slice(0, 60),
                    value: element.qual ? element.qual.slice(0, 60) : ''
                  }
                  this.socios.push(socio)
                }
              })

              if (this.socios.length > 0 && this.socioIndex < this.socios.length) {
                this.formSocio.nomeSocio.value = this.socios[this.socioIndex].label
                this.formSocio.cargoSocio.value = this.socios[this.socioIndex].value.slice(3).trim()
              } else {
                this.formSocio.nomeSocio.value = ''
                this.formSocio.cargoSocio.value = ''
              }
            }

            this.temInfosCnpj = true
          }
        })
        .catch(() => {
          swal({
            title: 'CNPJ não cadastrado e/ou encontrado na receita',
            icon: 'warning'
          })
          this.formRegister.disabledForm = false
          this.formRegister.complementoDisabled = false
          this.formRegister.nomeFantasiaDisabled = false
          this.loadingCnpj = false
          this.temInfosCnpj = false
        })
    },
    getByCnpj(cnpj) {
      this.loadingCnpj = true
      axios
        .get(this.$apiUrl + `ClientePre.svc/getbycnpj/${cnpj}`)
        .then((response) => {
          if (response.data !== '') {
            this.getInfosCnpj(cnpj)
            this.getInfosFinancialCnpj(cnpj)

            let telefone = response.data.PreTelefoneCelular

            if (telefone[0] == '0') telefone = telefone.substring(1)

            this.formRegister.telefoneCelular.value = telefone
            this.formRegister.nomeQuemCadastrou.value = response.data.Cli_Comprador;
            this.formRegister.email.value = response.data.PreEmail
            this.formRegister.confirmeEmail.value = response.data.PreEmail

            this.formRegister.nomeResponsavel.value = response.data.PreNomeemailnfe
            this.formRegister.emailResponsavel.value = response.data.PreEmailnfe

            this.formRegister.cidade.value = response.data.PreCidade

            if (response.data.CliLucroreal)
              this.formRegister.regimeTributario.value = this.getTaxRegimeOptions().filter((x) => x.code == response.data.CliLucroreal)[0]
          } else {
            location.href = '/login'
          }
        })
        .catch(() => {
          swal({
            title: 'Erro ao verificar CNPJ',
            icon: 'warning'
          })
        })
    },
    validateCnae: async function (val) {
      console.log('Validando cnae ', val)
      return axios.get('https://servicodados.ibge.gov.br/api/v2/cnae/subclasses/' + val).then((response) => {
        console.log('Validando cnae 2', response)
        return response.data && response.data.atividades && response.data.atividades.length > 0
      })
    },
    buildError: function (msg) {
      // Escreve o erro no formato padrão e retorna
      return { status: false, message: msg }
    },
    clearString: function (str) {
      return str.replace(/[^\d]/g, '')
    },
    requiredValidation(val) {
      // Valida campos obrigatórios e retorna mensagem padrão
      const validation = {
        status: !!val,
        message: !val ? this.requiredFieldMessage : ''
      }

      return validation
    },
    register: function () {
      this.formRegister.attemptSubmit = true

      if (this.socios.length == 0 && this.hasPartners) this.formSocio.attemptSubmit = true
      let qtdeSocios = this.socios.length - this.socioIndex
      if (qtdeSocios > 0 && this.hasPartners) {
        swal({
          title: `Ainda falta ${qtdeSocios} sócios para serem cadastrados!`,
          text: 'Por gentileza, cadastre-os.',
          icon: 'warning'
        })
        this.loadingRegister = false
        return
      }

      var dataFundacaoString = this.formRegister.fundacao.value.split('/')
      var data = new Date(dataFundacaoString[2] + '-' + dataFundacaoString[1] + '-' + dataFundacaoString[0] + 'T00:00:00')
      var preFundacao = data.getTime()

      let obj = {}

      obj.CliLucroreal = this.formRegister.regimeTributario.value.code
      obj.PreCnpj = this.formRegister.cnpj.value
      obj.PreRazaosocial = this.formRegister.razaoSocial.value
      obj.CliCnae = this.formRegister.cnae.value
      obj.PreTelefone = this.formRegister.telefone.value
      obj.PreTelefoneCelular = this.formRegister.telefoneCelular.value
      obj.PreCep = this.formRegister.cep.value
      obj.PreCidade = this.formRegister.cidade.value.label
      obj.EstUf = this.formRegister.estado.value.code
      obj.PreEndereco = this.formRegister.endereco.value
      obj.PreNumeroendereco = this.formRegister.numero.value
      obj.PreBairro = this.formRegister.bairro.value
      obj.PreComplementoendereco = this.formRegister.complemento.value
      obj.PreNomeemailnfe = this.formRegister.nomeResponsavel.value
      obj.PreComosoube = this.formRegister.comoConheceu.value.label
      obj.PreIe = this.formRegister.inscricaoEstadual.value
      obj.PreNomefantasia = this.formRegister.nomeFantasia.value
      obj.PreFundacao = '/Date(' + preFundacao + '-0300)/'
      obj.PreMei = this.formRegister.mei.value ? 1 : 0
      obj.PreEmail = this.formRegister.email.value
      obj.PreSite = this.formRegister.site.value
      obj.CidCodigo = this.formRegister.cidade.value.code
      obj.PreEmailnfe = this.formRegister.emailResponsavel.value
      obj.Clientesprecadastrossocios = this.socios
      obj.PreComprovanteResidencia = this.formRegister.comprovanteEndereco.value
      obj.TipoArquivo = this.formRegister.comprovanteEndereco.tipo
      obj.PreContratoSocial = this.formRegister.contratoSocial.value
      obj.TipoArquivo = this.formRegister.contratoSocial.tipo
      obj.AtividadesSecundarias = this.atividadesSecundarias
      obj.CliRural = this.formRegister.Clie
      obj.PreReceitaStatus = 'P'
      obj.Cli_Comprador = this.formRegister.nomeQuemCadastrou.value

      // Caso não tenha erros no formulário, faz o envio
      if (this.formErrors === 0) {
        this.loadingRegister = true
        // TODO: Inserir Ajax de cadastro aqui
        var xhr = new XMLHttpRequest()

        xhr.onload = () => {
          this.loadingRegister = false
          if (xhr.status == 200) {
            swal({
              title: 'Cliente cadastrado com sucesso',
              text: 'Seu cadastro foi concluído com sucesso. O time Comercial da Descarbonize entrará em contato em até dois dias úteis.',
              icon: 'success'
            }).then(() => (location.href = '/loja'))
          } else if (xhr.status == 205) {
            swal({
              title: 'Cliente já possui cadastro na Aldo:\r\n' + obj.PreCnpj,
              icon: 'warning'
            })
          } else if (xhr.status == 412 || xhr.status == 201) {
            swal({
              title: 'Seu cadastro está em processo de aprovação',
              text: 'Por favor, aguarde a confirmação para acessar sua conta. O processo de aprovação deve ser concluído em até dois dias úteis.',
              icon: 'warning'
            }).then(() => (location.href = '/login'))
          } else if (xhr.status == 413) {
            swal({
              title: 'Arquivo muito grande, tente usar arquivos menores que 2,5mb.',
              icon: 'warning'
            })
          } else if (xhr.status == 417) {
            swal({
              title: 'Instabilidade no serviço de consulta da Receita Federal',
              text: 'Clique em salvar novamente. Se persistir, tente novamente mais tarde.',
              icon: 'warning'
            })
          } else {
            swal({
              title: 'Ops! Algo deu errado, tente novamente em alguns instantes.',
              text: xhr.status + ' - ' + xhr.statusText,
              icon: 'error'
            })
          }
        }

        xhr.open('POST', this.$apiUrl + 'ClientePre.svc/concluircadastro')
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.withCredentials = true
        xhr.send(JSON.stringify(obj))
        // console.log("register");
      }
      // // console.log(this.$router);
    },
    getStates: function () {
      // TODO: Fazer ajax para busca de estados
      const states = [
        {
          code: 'AC',
          label: 'Acre'
        },
        {
          code: 'AL',
          label: 'Alagoas'
        },
        {
          code: 'AP',
          label: 'Amapá'
        },
        {
          code: 'AM',
          label: 'Amazonas'
        },
        {
          code: 'BA',
          label: 'Bahia'
        },
        {
          code: 'CE',
          label: 'Ceará'
        },
        {
          code: 'DF',
          label: 'Distrito Federal'
        },
        {
          code: 'ES',
          label: 'Espírito Santo'
        },
        {
          code: 'GO',
          label: 'Goiás'
        },
        {
          code: 'MA',
          label: 'Maranhão'
        },
        {
          code: 'MT',
          label: 'Mato Grosso'
        },
        {
          code: 'MS',
          label: 'Mato Grosso do Sul'
        },
        {
          code: 'MG',
          label: 'Minas Gerais'
        },
        {
          code: 'PA',
          label: 'Pará'
        },
        {
          code: 'PB',
          label: 'Paraíba'
        },
        {
          code: 'PR',
          label: 'Paraná'
        },
        {
          code: 'PE',
          label: 'Pernambuco'
        },
        {
          code: 'PI',
          label: 'Piauí'
        },
        {
          code: 'RJ',
          label: 'Rio de Janeiro'
        },
        {
          code: 'RN',
          label: 'Rio Grande do Norte'
        },
        {
          code: 'RS',
          label: 'Rio Grande do Sul'
        },
        {
          code: 'RO',
          label: 'Rondônia'
        },
        {
          code: 'RR',
          label: 'Roraima'
        },
        {
          code: 'SC',
          label: 'Santa Catarina'
        },
        {
          code: 'SP',
          label: 'São Paulo'
        },
        {
          code: 'SE',
          label: 'Sergipe'
        },
        {
          code: 'TO',
          label: 'Tocantins'
        }
      ]

      return states
    },
    loadCidades: function () {
      const self = this
      let cidade = {}

      self.formRegister.cidades = []

      let cidadeValue = self.formRegister.cidade.value
      try {
        cidadeValue = self.formRegister.cidade.value.toUpperCase()
      } catch (error) {
        cidadeValue = null
      }
      self.formRegister.cidade.value = null

      if (self.formRegister.estado.value) {
        $.ajax({
          url: this.$apiUrl + 'Cidades.svc/getcidades/' + self.formRegister.estado.value.code + '/N',
          dataType: 'json',
          contentType: 'application/json',
          type: 'GET',
          success: (data) => {
            self.formRegister.cidadeDisabled = false
            data.forEach((element, index) => {
              cidade = {}
              ;(cidade.code = element.CidCodigo), (cidade.label = element.CidCidade)
              self.formRegister.cidades.push(cidade)
            })

            if (cidadeValue) {
              let cidadeSelecionada = self.formRegister.cidades.filter((c) => c.label == cidadeValue)[0]
              if (cidadeSelecionada) {
                self.formRegister.cidadeDisabled = true
                self.formRegister.cidade = new this.$formInput(true, cidadeSelecionada)
              }
            } else self.formRegister.cidade = new this.$formInput(true)
          }
        })
      } else {
        self.formRegister.cidadeDisabled = true
        self.formRegister.cidade.value = null
      }
    },
    yesOrNoOptions: function () {
      const options = [
        { code: 1, label: 'Sim', value: true },
        { code: 2, label: 'Não', value: false }
      ]

      return options
    },
    getTaxRegimeOptions: function () {
      const taxRegime = [
        { code: 0, label: 'Lucro Real' },
        { code: 2, label: 'Simples Nacional' },
        { code: 3, label: 'Lucro Arbitrado' },
        { code: 4, label: 'Lucro Presumido' }
      ]

      return taxRegime
    },
    getMeetOptions: function () {
      const meetOptions = [
        { code: 1, label: 'Facebook' },
        { code: 2, label: 'Instagram' },
        { code: 3, label: 'YouTube' },
        { code: 4, label: 'Busca no Google' },
        { code: 5, label: 'Blog Aldo' },
        { code: 6, label: 'Anúncio na Internet' },
        { code: 7, label: 'Site Aldo' },
        { code: 8, label: 'LinkedIn' },
        { code: 9, label: 'Indicação de Outras Pessoas' },
        { code: 10, label: 'Outros' }
      ]

      return meetOptions
    }
  }
}
</script>
